import { Component, Inject, OnInit } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material";

import { EmailService } from "../shared/email.service";
import { SnackBarService } from "../../core/snack-bar.service";

import { EmailListing } from "../shared/email-listing.model";

@Component({
    template: require('./email-history-dialog.component.html'),
    styles: [require('./email-history-dialog.component.css')]
})
export class EmailHistoryDialogComponent implements OnInit {
    emailList: EmailListing[];
    enquiryID: number;
    loading: boolean;

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: any,
        public dialogRef: MatDialogRef<EmailHistoryDialogComponent>,
        private emailService: EmailService,
        private snackBarService: SnackBarService) { }

    ngOnInit() {
        this.enquiryID = this.data.enquiryID as number;
        this.getEmails();
    }

    getEmails(): void {
        this.loading = true;
        this.emailService.getListing(this.enquiryID)
            .then(list => {
                this.loading = false;
                this.emailList = list;
            })
            .catch(err => {
                this.loading = false;
                this.snackBarService.openSnackBar(err);
            });
    }
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./src/app/enquiry/email-history-dialog/email-history-dialog.component.ts